import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import api from "../../api";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSendOtp = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const response = await api.post(
        "/bulk-forgot-password",
        {
          email,
        }
      );

      if (response.data.status) {
        toast.success("OTP sent successfully");

        navigate("/verify-otp", {
          state: { email },
        });
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
        "Failed to send OTP"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex justify-center items-center p-4">

      <div className="w-full max-w-md bg-[#17130d] border border-[#D4AF37] rounded-2xl p-6">

        <h2 className="text-2xl font-bold text-[#D4AF37] mb-2">
          Forgot Password
        </h2>

        <p className="text-gray-400 mb-6">
          Enter your registered email
        </p>

        <form onSubmit={handleSendOtp}>
          <input
            type="email"
            required
            value={email}
            onChange={(e)=>setEmail(e.target.value)}
            placeholder="Enter email"
            className="w-full p-3 rounded-xl bg-black border border-[#6f5517] text-white"
          />

          <button
            type="submit"
            disabled={loading}
            className="w-full mt-4 bg-[#D4AF37] text-black font-bold py-3 rounded-xl"
          >
            {loading ? "Sending..." : "Send OTP"}
          </button>
        </form>

      </div>

    </div>
  );
};

export default ForgotPassword;